import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Questionnaire } from '../../../../types';
import { InputField } from '../../../../../../healtheraComponents';

interface Props {
  control: Control<Questionnaire>;
}

const TitleEditor = ({ control }: Props) => (
  <Controller
    control={control}
    name="title"
    rules={{
      required: {
        value: true,
        message: 'Questionnaire title is required'
      },
      pattern: {
        value: /\S/,
        message: 'Questionnaire title be non empty string'
      }
    }}
    render={({ field: { ref, ...otherField }, formState }) => (
      <InputField
        {...otherField}
        margintop="0"
        label="Questionnaire title"
        inputRef={ref}
        required
        error={formState.errors?.title?.message}
      />
    )}
  />
);

export default TitleEditor;
